import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _94a3f03c = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _543ffe4c = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _06c92a06 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _4af88b81 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _6a55c821 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _1133db35 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _bfdf859a = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _1f39b54e = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _24ea6c57 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _72ab6078 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _12af534c = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _47737cc4 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _eb85a6be = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _3b33cb4e = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _65856304 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _70a7f8eb = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _1eb09a61 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _64ad15da = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _65f0653a = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _48c41c0b = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _76e4b51e = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _6d584d65 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _aae6d430 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _719c84ae = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _761fc337 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _9534362e = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _60b66f07 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _6923767e = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _64873af8 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _44c13815 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _0fe8f2d8 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _2239294c = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _8bd095e4 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _006b5e16 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _39162231 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _b8b448a6 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _ba38d31e = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _08e94542 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _8b7dfa42 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _e2f963aa = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _4bdf7934 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _2523b479 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _db0af588 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _0503c3c8 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _51b3d772 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _758744e8 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _4a1160d8 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _b6d36a40 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _87dfe132 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _5d806daf = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _2d1cea60 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _6fed66c2 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _b92e2c16 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _02c6835a = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _49da7cee = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _43e62336 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _217d43ef = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _ae603c4c = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _561867be = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _4fca0d91 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _0c321dfc = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _b74de298 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _0378fcd9 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _63809aca = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _6ddbeeb6 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _31f0e506 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _316d426e = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _3ff4cf02 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _9f5c8e98 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _1e7dc88c = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _1ab6a6e4 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _40d86b08 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _81f3c108 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _3081e02c = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _94a3f03c,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _543ffe4c,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _06c92a06,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _4af88b81,
    name: "calendar"
  }, {
    path: "/customer",
    component: _6a55c821,
    name: "customer"
  }, {
    path: "/details",
    component: _1133db35,
    name: "details"
  }, {
    path: "/goals",
    component: _bfdf859a,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _1f39b54e,
    name: "maisoku"
  }, {
    path: "/media",
    component: _24ea6c57,
    name: "media"
  }, {
    path: "/privacy",
    component: _72ab6078,
    name: "privacy"
  }, {
    path: "/project",
    component: _12af534c,
    name: "project"
  }, {
    path: "/response",
    component: _47737cc4,
    name: "response"
  }, {
    path: "/achievement/output",
    component: _eb85a6be,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _3b33cb4e,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _65856304,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _70a7f8eb,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _1eb09a61,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _64ad15da,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _65f0653a,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _48c41c0b,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _76e4b51e,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _6d584d65,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _aae6d430,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _719c84ae,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _761fc337,
    name: "response-registration"
  }, {
    path: "/setting/announcement",
    component: _9534362e,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _60b66f07,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _6923767e,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _64873af8,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _44c13815,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _0fe8f2d8,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _2239294c,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _8bd095e4,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _006b5e16,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _39162231,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _b8b448a6,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _ba38d31e,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _08e94542,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _8b7dfa42,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _e2f963aa,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _4bdf7934,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _2523b479,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _db0af588,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _0503c3c8,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _51b3d772,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _758744e8,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _4a1160d8,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _b6d36a40,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _87dfe132,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _5d806daf,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _2d1cea60,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _6fed66c2,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _b92e2c16,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _02c6835a,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _49da7cee,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _43e62336,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _217d43ef,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _ae603c4c,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _561867be,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _4fca0d91,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _0c321dfc,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _b74de298,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _0378fcd9,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _63809aca,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _6ddbeeb6,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _31f0e506,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _316d426e,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _3ff4cf02,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _9f5c8e98,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _1e7dc88c,
    name: "property-property",
    children: [{
      path: "contact",
      component: _1ab6a6e4,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _40d86b08,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _81f3c108,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _3081e02c,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
